import React, { Component } from 'react'
import { connect } from 'react-redux';
import EditPriceItem from '../EditPriceItem/EditPriceItem';
import { Radio } from '@rmwc/radio';
import * as actionCreator from "../../action/extra_options/orderExtras.action.js"
import CurrencyFormat from 'react-currency-format';

class EngineeringDrawing extends Component {
   onchangeFn = (e) => {
      this.props.const_var.engineer_drawings_price_changed = false
      this.props.orderExtrasChangeValue(e, 'engineer_drawings', 'no')
   }
   render() {
      let free = (this.props.order_extra_items.engineer_drawings_name.toLowerCase() != 'none' || this.props.const_var.post_data?.['building']?.engineer_drawings_name?.toLowerCase() != 'none') && this.props.const_var.post_data['building']?.freebies?.length > 0 && this.props.const_var.post_data['building']?.freebies?.includes('drawing') ? true : false
      let isUserData = localStorage.getItem('userData') ? true : false
      let manufactureId = this.props.params.m_s_n

      let engineer_drawings_name = "";
      let engineer_drawings_price = 0;
      if(this.props.order_extra_items.engineer_drawings_name != undefined && this.props.order_extra_items.engineer_drawings_name != ''){
         engineer_drawings_name = this.props.order_extra_items.engineer_drawings_name.toLowerCase();
         engineer_drawings_price = this.props.order_extra_items.engineer_drawings;
      }else if(this.props.const_var.post_data?.['building']?.engineer_drawings_name != ""){
         engineer_drawings_name = this.props.const_var.post_data['building']?.engineer_drawings_name.toLowerCase();
         engineer_drawings_price = this.props.const_var.post_data['building']?.engineer_drawings;
      }
      return (
         <>
            <div className='form-group'>
               <label className="control-label">Drawings {free ? "(Free)" : null }</label>  
               {
                  this.props.const_var.c_m_a[this.props.params.p_b_t] != undefined &&
                  this.props.const_var.c_m_a[this.props.params.p_b_t].drawings != undefined && this.props.const_var.c_m_a[this.props.params.p_b_t].drawings.length > 0 &&
                  this.props.const_var.c_m_a[this.props.params.p_b_t]?.drawings?.map((item, idx) => {
                     let leanToDrawing = undefined
                     let isEmailForPricing = false
                     if((this.props.params.m_s_n == 148 || this.props.params.m_s_n == 121 || this.props.params.m_s_n == 8 || this.props.params.m_s_n == 181) && item.name.toLowerCase().includes('email for pricing')){
                        isEmailForPricing = true
                     }
                     if(this.props.const_var.c_m_a[this.props.const_var.c_m_a[this.props.params.p_b_t].default_lean_id] != undefined){
                        leanToDrawing = this.props.const_var.c_m_a[this.props.const_var.c_m_a[this.props.params.p_b_t].default_lean_id]
                        if(leanToDrawing != undefined){
                           leanToDrawing = leanToDrawing.drawings
                        }
                     }
                     if((!this.props.const_var.crmSetting.is_Edit || this.props.const_var.isFromPickThis) && manufactureId == 3 && item.name == "None") return null
                     return (
                        <div className='radio-group'>
                           <Radio
                              label={item.name}
                              value={item.name}
                              name="engineer_drawings"
                              checked={(engineer_drawings_name == item.name.toLowerCase()) ? true : false}
                              onChange={e => this.props.orderExtrasChangeValue(e, 'engineer_drawings', 'no', item.cost, item.name,leanToDrawing)}
                           />
                           {/* {((this.props.const_var.post_data.building!=undefined && this.props.const_var.loginSession == true))?
                              <aside className="price-box">
                                 <EditPriceItem jsonObj={this.props.const_var.post_data.building.connection_fee_side} jsonObjKey="connection_fee_side"/>
                                 </aside>
                                 :
                                 <div className='price-box-type-2' >
                                    {this.props.const_var.hide_price_calculation != 1 && this.props.const_var.loginSession == false && (this.props.const_var.post_data.building!=undefined && this.props.const_var.post_data.building.connection_fee_side!=undefined) && this.props.const_var.post_data.building.connection_fee_side !== 0 && 
                                       <CurrencyFormat value = {this.props.const_var.post_data.building.connection_fee_side} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                    }
                                 </div>
                              } */}
                              
                           {this.props.order_extra_items.engineer_drawings_name != undefined && this.props.order_extra_items.engineer_drawings_name != '' && !isEmailForPricing &&
                              engineer_drawings_name == item.name.toLowerCase() && (this.props.order_extra_items.engineer_drawings_name.toLowerCase() != 'none'|| this.props.const_var.post_data?.['building']?.engineer_drawings_name?.toLowerCase() != 'none' ) &&
                              // <TextField
                              //    // label="Engineer Drawings"
                              //    className="astrick"
                              //    maxLength="8"
                              //    onChange={e => this.props.orderExtrasChangeValue(e, 'engineer_drawings', 'yes')}
                              //    value = {this.props.order_extra_items.engineer_drawings}
                              //    onKeyUp={e=> validate.numericCheckwithDecimalVal(e)}
                              //    name="engineer_drawings"
                              // />
                              <>
                                 {(this.props.const_var.hide_price_calculation != 1 && this.props.const_var.loginSession == false && isUserData == false ) ?
                                    <>
                                       <div className="price-box-type-2">
                                          <CurrencyFormat value={engineer_drawings_price} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                       </div>
                                    </>
                                    :
                                    <>
                                       {((this.props.const_var.post_data.building != undefined && this.props.const_var.loginSession == true )) ?
                                          <div  className={free ? 'price-box disabled' : 'price-box'}>
                                             {/* <EditPriceItem onChangeFnNew={true} onchangeFn={e => this.props.orderExtrasChangeValue(e, 'engineer_drawings', 'yes')} jsonNewObj={(this.props.sel_engineer_drawings_option==undefined)?0:this.props.sel_engineer_drawings_option.cost} jsonObjKey="order_extra_items"/>     */}
                                             <EditPriceItem onChangeFnNew={true} onchangeFn={e => this.onchangeFn(e)} jsonNewObj={engineer_drawings_price} jsonObjKey="engineer_drawings" />
                                          </div>
                                          : null}
                                    </>
                                 }
                              </>
                           }
                           {
                              manufactureId == 4 || manufactureId == 10 || manufactureId == 180
                              ?
                                 <div className={item.name.includes("Generic Drawing") || item.name.includes("Engineered Drawing") ? 'dw-info' : "d-none"}>
                                       <span className='drawing-info-text'>{item.name.includes("Generic Drawing") ? `(Generic plans only available for buildings under 31' wide)` : (item.name.includes("Engineered Drawing") ? `(Additional cost not shown here)` : "") }</span>
                                 </div>
                              :
                              null
                           }
                        </div>
                     )
                  })
               }
               {/* <>
                  <div className='col-8 drawing-col-sec'>
                     <Radio
                        label={'None'}
                        value={'None'}
                        className='w-full'
                        name="engineer_drawings"
                        checked={(this.props.sel_engineer_drawings_option.name == 'None')?true:false}
                        onChange={e => this.props.orderExtrasChangeValue(e, 'engineer_drawings', 'no', 0)}
                     />
                  </div>
               </> */}
            </div>

         </>
      )
   }
}

const mapStateToProps = (state) => {
   return { ...state.reducer, ...state.orderExtrasReducer }
}

export default connect(
   mapStateToProps,
   actionCreator
)(EngineeringDrawing);